import React, { useEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { trackPageView } from '@app/lib/analytics';
import i18n from '@app/lib/i18n';
import { isLang } from '@app/lib/site';
import { NotFoundPage } from '@pages';
import { ConsentBanner, Footer, Navbar } from '@widgets';

export default function Layout(): React.JSX.Element {
  const { lang } = useParams();
  const valid = isLang(lang);
  const target = valid ? lang : 'en';
  const { pathname } = useLocation();

  // page_view на каждую страницу, включая переходы внутри сайта без перезагрузки.
  useEffect(() => {
    trackPageView();
  }, [pathname]);

  // Ресурсы встроены, смена языка синхронная — важно для пререндера и гидратации.
  if (i18n.language !== target) {
    i18n.changeLanguage(target);
  }

  return (
    <>
      <Navbar />
      {valid ? <Outlet /> : <NotFoundPage />}
      <Footer />
      <ConsentBanner />
    </>
  );
}
